(function (Drupal, drupalSettings) {
  Drupal.behaviors.leafletAssuetude = {
    attach: function (context, settings) {
      const mapElement = context.querySelector(".pole_4 #map");
      if (mapElement && !mapElement.dataset.leafletAssuetudeProcessed) {
        mapElement.dataset.leafletAssuetudeProcessed = "true";

        const planes = [
          [
            "<strong>Service de santé mentale de Jolimont</strong>Rue Ferrer 198-200<br>7100 Haine-Saint-Paul<br><a href='tel:065 23 33 48' class='tel'>065 23 33 48</a>",
            50.47714,
            4.216654,
          ],
          [
            "<strong>Le Pichotin</strong>Service de santé mentale de Lobbes<brRue Albert 1er 28<br>6540 Lobbes<br><a href='tel:071 55 92 30' class='tel'>071 55 92 30</a>",
            50.348942,
            4.265301,
          ],
          [
            "<strong>Le Portail</strong>Service de santé mentale de Beaumont<br>Rue de la déportation 5<br>6500 Beaumont<br><a href='tel:071 70 07 59' class='tel'>071 70 07 59</a>",
            50.237763,
            4.236195,
          ],
          [
            "<strong>L’Espérance, centre de postcure</strong>Rue Fosteau 42<br>6530 Thuin<br><a href='tel:071 59 34 96' class='tel'>071 59 34 96</a>",
            50.334919,
            4.284233,
          ],
        ];

        const map = L.map(mapElement).setView([50.5, 3.8], 10);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> Contributors',
          maxZoom: 18,
        }).addTo(map);

        const jolimontIcon = L.icon({
          iconUrl:
            "/themes/custom/expansion/assets/dist/images/jolimont-map-icon-assuetude.png",
          iconSize: [64, 64],
          iconAnchor: [32, 32],
          popupAnchor: [0, -30],
        });

        const markerArray = planes.map(([popupText, lat, lng]) => {
          return L.marker([lat, lng], { icon: jolimontIcon })
            .bindPopup(popupText, { minWidth: 250 })
            .addTo(map);
        });

        const group = L.featureGroup(markerArray);
        map.fitBounds(group.getBounds());
      }
    },
  };
})(Drupal, drupalSettings);
